<template>
  <div class="container">
    <home-title
      title="最新教程"
      link="https://lib.yiihuu.com/list/index.php"
      :icon="require('@/assets/images/home/home_title/icon1.svg')"
    ></home-title>
    <div class="course_box">
      <div
        class="course_item"
        v-for="e in newData"
        :key="e.album_id"
        @click="goStudent(e.album_id)"
      >
        <img class="course_img" :src="$homeSrc(e.album_smpicpath)" alt="" />
        <div class="course_info">
          <p class="toh2">
            {{ e.album_name }}
          </p>
          <div class="info_bottom">
            <div class="left dfAic">
              <img src="@/assets/images/home/item_icon1.svg" alt="" />{{
                e.album_level_sort
              }}
            </div>
            <div class="right dfAic">
              <img src="@/assets/images/home/item_icon2.svg" alt="" />{{
                e.play_count
              }}人在学
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import homeTitle from "./components/homeTitle";
export default {
  name: "newCourse",
  components: { homeTitle },
  props: {
    newData: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {};
  },

  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  methods: {
    goStudent(id) {
      window.open(`https://lib.yiihuu.com/video/album.php?aid=${id}`);
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding-top: 40px;
}
@media screen and (max-width: 1500px) and (min-width: 270px) {
  .course_item {
    &:nth-child(5) {
      display: none;
    }
  }
}
</style>
